import _regeneratorRuntime from "/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/online-shopper-web/online-shopper-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import Ajv from 'ajv';
import { isUndefined } from 'lodash-es';
import { patchStorage, getStorage } from '../local-storage';
import tradeInSchema from '../schema/trade-in.json';
var ajv = new Ajv();
export var Condition;

(function (Condition) {
  Condition["High"] = "high";
  Condition["Low"] = "low";
  Condition["Target"] = "target";
})(Condition || (Condition = {}));
/**
 * Ingests a trade in and persists it to local storage for future retrieval.
 * Validates the data against the `TradeIn` schema, will throw an error if
 * the data provided is invalid or if it is unable to save.
 */


export function ingestTradeIn(_x) {
  return _ingestTradeIn.apply(this, arguments);
}
/**
 * Retrieves the last Trade In from localStorage.
 * Will return an empty object if no Trade In was found.
 *
 */

function _ingestTradeIn() {
  _ingestTradeIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var tradeInValidator, isValid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tradeInValidator = ajv.compile(tradeInSchema);
            isValid = tradeInValidator(data);

            if (isValid) {
              _context.next = 5;
              break;
            }

            console.error("DI CCDP :: IngestTradeIn validation failure; ".concat(JSON.stringify(tradeInValidator.errors)));
            throw new Error('DI CCDP :: IngestTradeIn validation failure');

          case 5:
            patchStorage({
              tradeIn: data
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _ingestTradeIn.apply(this, arguments);
}

export function egressLastTradeIn() {
  return _egressLastTradeIn.apply(this, arguments);
}

function _egressLastTradeIn() {
  _egressLastTradeIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var storage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            storage = getStorage();

            if (isUndefined(storage.tradeIn)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", storage.tradeIn);

          case 3:
            return _context2.abrupt("return", {});

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _egressLastTradeIn.apply(this, arguments);
}